export type SseMessage = { event: string; data: string };

const DEFAULT_EVENT = "message";
const FRAME_DELIMITER = /\r?\n\r?\n/;

/** Incremental text/event-stream parser; feed raw chunks, get complete frames. */
export class SseParser {
	private buffer = "";

	push(chunk: string): SseMessage[] {
		this.buffer += chunk;
		const parts = this.buffer.split(FRAME_DELIMITER);
		this.buffer = parts.pop() ?? "";
		return parts.map(parseFrame).filter((m): m is SseMessage => m !== null);
	}
}

function parseFrame(frame: string): SseMessage | null {
	const fields = frame
		.split(/\r?\n/)
		.filter((line) => line !== "" && !line.startsWith(":"))
		.map(splitField);
	const data = fields.filter((f) => f.name === "data").map((f) => f.value);
	if (data.length === 0) return null;
	const event = fields.find((f) => f.name === "event")?.value ?? DEFAULT_EVENT;
	return { data: data.join("\n"), event };
}

function splitField(line: string): { name: string; value: string } {
	const idx = line.indexOf(":");
	if (idx === -1) return { name: line, value: "" };
	const value = line.slice(idx + 1);
	return { name: line.slice(0, idx), value: value.startsWith(" ") ? value.slice(1) : value };
}
